import React from 'react';
import BookModal from "../../screens/BookModal";
import ExtendModal from "../../screens/ExtendModal";
import EndModal from "../../screens/EndModal";
import AuthenticationModal from "../../screens/AuthenticationModal";
import SpaceQrModal from "../../screens/SpaceQrModal";

const ModalsContainer = () => {
    return (
        <>
            <BookModal />
            <ExtendModal />
            <EndModal />
            <AuthenticationModal />
            <SpaceQrModal />
        </>
    );
};

export default ModalsContainer;
